import { render, staticRenderFns } from "./RoleGrid.vue?vue&type=template&id=71d982d8&scoped=true&"
import script from "./RoleGrid.vue?vue&type=script&lang=js&"
export * from "./RoleGrid.vue?vue&type=script&lang=js&"
import style0 from "./RoleGrid.vue?vue&type=style&index=0&id=71d982d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d982d8",
  null
  
)

export default component.exports